import React from 'react'

function SuccessPopup() {
  return (
    <div className='popup'>
      <div className="popup-content">
        <h2>Vielen Dank! Ihre Anfrage wurde versendet!</h2>
        <p>Wir werden Ihre Anfrage schnellstmöglich bearbeiten und uns innerhalb von 48 Stunden (werktags) bei Ihnen melden.</p>
        <button onClick={() => window.location.reload()} type='button'>OK</button>
      </div>
    </div>
  )
}

export default SuccessPopup